<!-- 预支付历史已缴费 -->
<template>

    <!-- 查询结果页 -->
    <div>
        <van-nav-bar
                title="历史已缴费数据"
                left-text="返回"
                left-arrow
                @click-left="onClickLeft"
        />
        <div class="historyBox">
            <Head v-if='logo' :logo='logo'></Head>
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh" head-height='120'>
                <div class="cont">
                    <div class="touch"></div>
                    <div v-if='dataList.length>0'  @touchmove.stop>
                        <List :dataList='dataList' @func="handleItem(arguments)"></List>
                        <div class="replay" @click="handlePage" v-if='iscode == false'>
                            <div v-if="hasmore">
                                <div v-if='pageLoading'>
                                    <van-loading size="24px">加载中...</van-loading>
                                </div>
                                <div v-else>
                                    <van-icon name="replay" />点击加载更多数据
                                </div>
                            </div>
                            <div v-else>暂无更多数据</div>
                        </div>
                    </div>
                    <div v-else class="nodata">
                        <van-loading size="24px" v-if='dataList.length==0 && loading && refreshing==false'>加载中...</van-loading>
                        <div v-if='dataList.length==0 && !loading'>暂无数据</div>
                    </div>
                </div>
                <Foot v-if='list && list.bottomMessage && list.bottomMessage.length>0' :list='list'></Foot>

            </van-pull-refresh>
        </div>

        <!-- 弹窗 -->
        <van-dialog v-model="showModel" title="收费项目明细">
            <div class="content">
                <div
                        v-for="(item,index) in detailList"
                        :key="index"
                >{{item.itemName}}:{{Number(item.actualAmt).toFixed(2)}}{{item.unit}}</div>
            </div>
        </van-dialog>

    </div>
</template>

<script>
    import Foot from "@/components/foot";
    import Head from "@/components/head";
    import List from "@/components/list";
    import { Dialog,Toast } from "vant";
    import {isEmpty} from "@/utils/common";
    import {judgeVde} from "@/utils/publicJudge";
    export default {
        components: {
            Foot,
            Head,
            List
        },
        data() {
            return {
                studentId: "",
                vde: "",
                dataList: [],
                loading: true,
                usepay: true,
                list: [], //温馨提示列表
                logo: "",
                page: 1,
                limit: 5,
                total: 0,
                hasmore: true,
                pageLoading: false,
                showModel: false,
                detailList: [],
                refreshing: false,
                iscode:false
            };
        },
        created() {
            if (this.$route.query.vde === undefined) {
                this.vde = "";
            } else {
                this.vde = this.$route.query.vde;
            }
            //判断vde
            judgeVde({vde:this.vde},this)
            this.studentId = this.$route.query.mark;
            if(isEmpty(this.studentId)){
                Toast.clear();
                Dialog.alert({
                    title: "提示",
                    message: "地址不正确，请刷新后重试"
                }).then(() => {
                    //返回上一页
                    this.$router.go(-1)
                });
            }
            this.getData();

            this.getFootData();
            this.getHeadImg();
        },
        methods: {
            // 子传父的参数（用于弹窗）
            handleItem(data) {
                this.showModel = data[0];
                this.detailList = data[1];
            },
            // 下拉刷新
            onRefresh() {
                this.page = 1;
                this.limit = 5;
                this.dataList=[]
                this.loading = true
                setTimeout(() => {
                    this.getData();
                    this.hasmore = true;
                    this.refreshing = false
                    Toast("刷新成功");
                }, 1000);
            },

            // 获取头像
           getHeadImg() {
            let data = {};
            data.vde = this.vde;
            this.request({
                url:'/webPortal/websitConfig',
                method:'get',
                params:data
            }).then((res)=>{
                if (res.data.code == 1000) {
                if (res.data.result.logoUrlLogin) {
                    this.logo = res.data.result.logoUrlLogin;
                }else {
                    this.logo = require("@/assets/img/logo.png");
                }
                document.title=res.data.result.websitTitle
                sessionStorage.setItem("title", res.data.result.websitTitle);
                } else if (res.data.code != 1000){
                this.$router.push({ path: "/404" });
                }
            })
            },
            // 获取底部数据
            getFootData() {
                let data = {
                    vde:this.vde,
                    type:1
                };
                this.request({
                    url:'/systemManage/mobileGetMessage',
                    method:'get',
                    params:data
                }).then((res)=>{
                    if (res.data.code != 1000) {
                        //this.$router.push({ path: "/404" });
                    } else {
                        this.list = res.data.result;
                    }
                })
            },
            // 分页
            handlePage() {
                this.pageLoading = true;
                if (this.dataList.length < this.total) {
                    this.page++;
                    this.getData();
                } else {
                    setTimeout(() => {
                        this.pageLoading = false;
                        this.hasmore = false;
                    }, 500);
                }
            },
            // 从查询页进来的
            getData() {
                if (this.page == 1) {
                    this.dataList = [];
                    this.loading = true;
                } else {
                    this.pageLoading = true;
                }
                let data = {
                    studentId: this.studentId,
                    vde: this.vde,
                    page: this.page,
                    limit: this.limit
                };
                this.request({
                    url:'/prepaid/listHistory',
                    method:'get',
                    params:data
                }).then((res)=>{
                    this.loading = false;
                    this.pageLoading = false;
                    if (res.data.code == 1000) {
                        if (res.data.result != null) {
                            this.dataList = this.dataList.concat(res.data.result.list);
                            this.total = res.data.result.total;
                        }
                        if(this.dataList.length <=0){
                            Toast.clear();
                            Dialog.alert({
                                title: "提示",
                                message: "暂无历史已缴费预支付数据"
                            }).then(() => {
                                //返回上一页
                                this.$router.go(-1)
                            });
                        }
                        this.$forceUpdate();
                    }
                })
            },
            // 页面点击返回
            onClickLeft:function(){
                this.$router.go(-1)
            },
        }
    };
</script>

<style lang="scss" scoped>
.historyBox {
    padding: 0 2vw;
    box-sizing: border-box;
}
    .nodata {
        text-align: center;
        font-size: 14px;
        margin: 30px 0;
        color: #888;
    }
    .cont {
        margin-top: 10px;
        position: relative;
        .replay {
            text-align: center;
            color: #999;
        }
        .touch {
            height: 30vh;
            width: 100vw;
            position: absolute;
            left: 0;
            top: 0;
            z-index: 10;
        }
    }
    .content {
        text-align: center;
        padding: 15px 0;
        line-height: 24px;
    }
</style>
